import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RootEpic} from "./epics/root.epic";
import {PollEpics} from "./epics/poll.epics";
import {ConfigEpics} from "./epics/config.epics";
import {QuestionEpics} from "./epics/question.epics";
import {ScriptQuestSetsEpics} from "./epics/scriptQuestSets.epics";
import {ConfigService, PollService} from "./services";

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({

    imports: [CommonModule],

    declarations: [],

    exports: []
})
export class StorageModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: StorageModule,
            providers: [
                RootEpic, PollEpics, ConfigEpics, QuestionEpics, ScriptQuestSetsEpics,

                ConfigService, PollService
            ]
        };
    }
}
